<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20" style="margin-bottom:30px;">
        <el-col :span="24">
          <el-card shadow="always" :body-style="{ background: '#f5f5f5' }" v-if="order.customer">
            <div slot="header" class="clearfix">
              <h2 class="card-title">
                <router-link
                  :to="'/customer/edit/'+order.customer.id"
                >{{order.customer.firstname}} {{order.customer.lastname}}</router-link>
                <small class="pull-right">
                  Order ID: {{order.id}}
                  <br />
                  <span
                    class="text-muted"
                    v-if="order.dateCreated != null"
                  >{{order.dateCreated | moment('DD/MM/YYYY')}} {{order.dateCreated | moment("HH:mm:ss") }}</span>
                </small>
              </h2>
              <i class="ti-email"></i>
              {{order.customer.email}}
              <i
                v-if="order.customer.shippingAddress"
                class="fa fa-phone"
              ></i>
              <span v-if="order.customer.shippingAddress">{{order.customer.shippingAddress.phone}}</span>
            </div>
            <el-button
            plain
              v-show="order.customer.email"
              v-on:click.prevent="loginAsCustomer"
              type="primary"
            >Login As Customer</el-button>
            <el-button
            plain
            type="primary"
              v-if="order.status=='2'"
              @click="resendBooking"
              class="btn btn-primary btn-sm"
            >Resend Booking Email</el-button>
            <span class="pull-right">
              <el-select v-model="order.status" :class="order.status | orderStatus" placeholder="Select">
                <el-option
                  v-for="status in statuses"
                  :key="status.value"
                  :label="status.label"
                  :value="status.value"
                ></el-option>
              </el-select>

              <el-button plain type="primary" icon="fa fa-save" :class="order.status | orderStatus" @click="updateStatus()">Change</el-button>
            </span>
          </el-card>
          <el-card shadow="always" :body-style="{ background: '#f5f5f5' }" v-else>
            <div slot="header" class="clearfix">
            <h2 class="card-title">This order has no customer assigned</h2>
            <span class="pull-right">
              <el-select v-model="order.status" :class="order.status | orderStatus" placeholder="Select">
                <el-option
                  v-for="status in statuses"
                  :key="status.value"
                  :label="status.label"
                  :value="status.value"
                ></el-option>
              </el-select>

              <el-button plain type="primary" icon="fa fa-save" :class="order.status | orderStatus" @click="updateStatus()">Change</el-button>
            </span>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- BOOKING SUMMARY -->

      <div class="row">
        <div class="col-lg-6 col-md-12">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Product Summary</h4>
            </div>
            <div class="card-content">
              <div class="row">
                <div class="col-md-12" v-for="(product,index) in boughtProducts" :key="index">
                  <hr />
                  <div class="form-group" v-if="product.onlineCourseExpiryDateSet != 0 || product.product.type=='classroom course' ">

                     <h4>{{product.product.name}} <small class="pull-right">{{product.product.type  | capitalize}}</small></h4>
                    
                    <el-steps
                      :space="200"
                      finish-status="success"
                      v-if="product.product.type=='classroom course' || product.product.type=='online course' || product.product.type=='combined course'"
                    >
                      <el-step  v-if="product.product.type!=='classroom course'"
                        title="Signed"
                        :description="product.signedLearnerAgreement==1?'Learner Agreement \n'+$options.filters.moment(product.signedDate,'DD/MM/YYYY'):'Learner Agreement'"
                        :status="product.signedLearnerAgreement==1?'success':'error'"
                      ></el-step>
                      <el-step
                        v-if="product.product.type=='combined course' || product.product.type=='classroom course'"
                        title="Classroom"
                        description="Attended"
                        :status="product.classRoomCourseAttended==1?'success':'error'"
                      ></el-step>
                      <el-step
                        v-if="product.product.type=='combined course' || product.product.type=='classroom course'"
                        title="Classroom"
                        description="Passed"
                        :status="product.classRoomCoursePassed==1?'success':'error'"
                      ></el-step>
                      <el-step
                      v-if="product.product.type!=='classroom course'"
                        title="Online Course"
                        description="Passed"
                        :status="product.onlineCoursePassed==1?'success':'error'"
                      ></el-step>
                      <el-step
                        title="Certificate"
                        description="Approved"
                        :status="product.certDue?'success':'error'"
                      ></el-step>
                                            <el-step
                        title="Certificate"
                        :description="product.certRequested?'Request '+product.certRequested:'Not Requested'"
                        :status="product.certRequested?'success':'error'"
                      ></el-step>
                      <el-step
                        title="Certificate"
                        :description="product.certSentDate?'Sent '+product.certSentDate:'Not Sent'"
                        :status="product.certSent?'success':'error'"
                      ></el-step>
                 
                    </el-steps>
                    </div>
                    <div v-else>
                      <h4>{{product.product.name}} <small class="pull-right">{{product.product.type  | capitalize}}</small>{{ product.productTotal }}</h4>
                      <!-- IF extension show button to link to relevant order -->
                      <p v-if="product.relativeOrderBoughtProductId != 0 && product.relativeOrderBoughtProductId != null">This extension is attached to a specific product <strong>{{product.relativeOrderBoughtProductId}}</strong>&nbsp;&nbsp;
                      <el-tooltip effect="light" style="display:inline" content="View the order and product that this extension was purchased for." placement="top">
                        <el-button
                        class="inline"
                        plain
                        type="primary"
                        @click="getRelativeOrder(product.relativeOrderBoughtProductId)"
                      >View related order <i class="fa fa-external-link"></i></el-button>
                      </el-tooltip>
                      </p>
                      <p v-if="product.product.name == 'Job Listing'">This payment is for a job listing on the TEFL Org website
                      <el-tooltip effect="light" style="display:inline" content="View the job listing" placement="top">
                        <a
                          class="btn btn-xs"
                          style="margin:-8px 0 0 5px;"
                          :href="'https://www.tefl.org/?post_type=job_listing&p=' + getJobID(order.externalPayments[0].description)"
                          target="_BLANK"
                        >View</a>
                      </el-tooltip>
                      <el-tooltip effect="light" style="display:inline" content="Edit the job listing" placement="top">
                        <a
                          class="btn btn-xs"
                          style="margin:-8px 0 0 5px;"
                          :href="'https://www.tefl.org/wp-admin/post.php?post=' + getJobID(order.externalPayments[0].description) + '&action=edit'"
                          target="_BLANK"
                        >Edit</a>
                      </el-tooltip>
                      </p>
                    </div>

                  <div
                    class="row"
                    style="padding-bottom:20px;"
                    v-if="product.product.type=='online course' || product.product.type=='combined course'"
                  >
                    <div class="col-md-4">
                      <h5>Expires</h5>
                      <el-button plain disabled :type="product.onlineCourseExpiryDate<today?'danger':'success'">
                        {{product.onlineCourseExpiryDate | moment("DD/MM/YYYY")}}
                        <small>{{product.onlineCourseExpiryDate | moment('from', 'now')}}</small>
                      </el-button>
                    </div>
                    <div class="col-md-6">
                      <h5>Edit</h5>

                      <el-date-picker
                        v-model="newExpiryDate[product.id]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="Pick a date"
                      ></el-date-picker>
                      <el-button
                        class="inline"
                        plain
                        type="primary"
                        @click="updateExpiryDate(product.id)"
                      >{{expiryText}}</el-button>
                    </div>
                    
                  </div>

              <div class="form-group" v-if="product.product.type=='online course' || product.product.type=='combined course'">
         
                <UnitTranscript :customer="order.customer" :product="product" :certid="order.customer.id"/>
                <em>Beta: Please report any layout or other issues to IT</em>
              <hr>

                <H5><strong>Available Extensions:</strong></H5>
                <p><small><i>Available extensions can be applied from the customer dashboard on the website.</i></small></p>

                <small v-if="product.oneWeekExtensions != 0">
                  One week (PRE) - <strong>{{product.oneWeekExtensions}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,153)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'1week')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.oneWeekExtensionsPost != 0">
                  One week (POST) - <strong>{{product.oneWeekExtensionsPost}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,154)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'1weekpost')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.oneMonthExtensions != 0">
                  One month (PRE) - <strong>{{product.oneMonthExtensions}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,155)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'1month')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.oneMonthExtensionsPost != 0"> 
                  One month (POST) - <strong>{{product.oneMonthExtensionsPost}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,156)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'1monthpost')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.twoMonthExtensions != 0">
                  Two month (PRE) - <strong>{{product.twoMonthExtensions}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,157)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'2months')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.twoMonthExtensionsPost != 0">
                  Two month (POST) - <strong>{{product.twoMonthExtensionsPost}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,158)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'2monthspost')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.threeMonthExtensions != 0">
                  Three month (PRE) - <strong>{{product.threeMonthExtensions}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,159)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'3months')">Remove (-1)</el-button>
                  <br>
                </small>
                <small v-if="product.threeMonthExtensionsPost != 0">
                  Three month (POST) - <strong>{{product.threeMonthExtensionsPost}} available</strong>&nbsp;&nbsp;
                  <el-button plain type="success" size="mini" class="" @click="applyExtension(product.id,160)">Apply</el-button>
                  <el-button plain type="danger" size="mini" class="" @click="removeExtension(product.id,'3monthspost')">Remove (-1)</el-button>
                  <br>
                </small>
                
                <p v-if="
                  product.oneWeekExtensions == 0 && 
                  product.oneWeekExtensionsPost == 0 && 
                  product.oneMonthExtensions == 0 && 
                  product.oneMonthExtensionsPost == 0 && 
                  product.twoMonthExtensions == 0 && 
                  product.twoMonthExtensionsPost == 0 && 
                  product.threeMonthExtensions == 0 && 
                  product.threeMonthExtensionsPost == 0">
                    Customer has no extensions available for this course.
                </p>
                    
            </div>

            <div  v-if="product.product.type=='online course' || product.product.type=='combined course'">
              <H5><strong>Add Extensions:</strong></H5>
              <el-button plain type="primary" class="" @click="addExtension(product.id,'1week')">+ One Week</el-button>
              <el-button plain type="primary" class="" @click="addExtension(product.id,'1month')">+ One Month</el-button>
              <el-button plain type="primary" class="" @click="addExtension(product.id,'2months')">+ Two Months</el-button>
              <el-button plain type="primary" class="" @click="addExtension(product.id,'3months')">+ Three Months</el-button>
            </div>
                  <div class="form-group" v-if="product.classRoom != null">
                    <hr>
                     
                    <h5><strong>Classroom Element:</strong></h5>
                    

                      <div class="row">
                        <div class="col-sm-2">
                          <h6>Starts</h6>
                              {{product.classRoom.startDate | moment("DD/MM/YYYY")}}
                        </div>
                        <div class="col-sm-2">
                          <h6>Ends</h6>
                              {{product.classRoom.endDate | moment("DD/MM/YYYY")}}
                        </div>
                        <div class="col-sm-2">
                          <h6>Code</h6>
                           {{product.classRoom.code}}
                        </div>
                        <div class="col-sm-2">
                          <h6>Town</h6>
                            {{product.classRoom.venue.town}}
                        </div>
                        <div class="col-sm-4">
                          <h6>Venue</h6>
                            {{product.classRoom.venue.name}}
                        </div>
                      </div>

                    <br /><br />
                    <el-tooltip effect="light" style="display:inline" content="View Classroom" placement="top">
                       <router-link :to="'/classroom/edit/'+product.classRoom.id" ><el-button plain type="primary">View Details <i class="fa fa-external-link"></i></el-button>
                      </router-link></el-tooltip>
                  </div>
                  
                  <div
                    class="row"
                    v-if="product.product.type=='classroom course' || product.product.type=='online course' || product.product.type=='combined course'"
                  >
                    <div class="col-md-12">
                      <hr>
                      <h5><strong>Available Actions:</strong></h5>
                      

                  <el-dialog
                      v-if="product.classRoom"
                      center
                      title="Reschedule"
                      :visible.sync="changeClassroomVisible"
                      :modal=false
                   
                    > 
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                          <span>Current</span>
                        </div>
                          Code:  {{product.classRoom.code}}<br />
                          Start Date: {{product.classRoom.startDate | moment('DD/MM/YYYY')}} {{product.classRoom.startTime | time}}<br />
                          End Date: {{product.classRoom.endDate | moment('DD/MM/YYYY')}} <br />
                          Venue: {{product.classRoom.venue.town}} - {{product.classRoom.venue.name}}
                      </el-card>
                      <br />
                      <component
                        :is="showIt"
                        :filter="classrooms"
                        v-model="classrooms"
                        v-on:loading="loadingClassrooms = $event"
                        v-on:update:classrooms="classrooms = $event"
                      ></component>
                    
                      <el-table :data="classrooms" :loading="settingClass">
                        <el-table-column label="Code" min-width="70">
                          <template slot-scope="props">
                           {{props.row.code}}
                          </template>
                        </el-table-column>
                        <el-table-column label="StartDate" min-width="70">
                          <template slot-scope="props">{{props.row.startDate}}</template>
                        </el-table-column>
                        <el-table-column prop="startTime" label="Time" min-width="50">
                          <template slot-scope="props">{{props.row.startTime | time}}</template>
                        </el-table-column>
                        <el-table-column label="EndDate" min-width="70">
                          <template slot-scope="props">{{props.row.endDate}}</template>
                        </el-table-column>
                        <el-table-column label="Venue" min-width="70">
                          <template slot-scope="props">{{props.row.venue.name}}</template>
                        </el-table-column>
                        <el-table-column label="Places Left" min-width="40">
                          <template
                            slot-scope="props"
                          >{{props.row.maxAttendees-props.row.numAttendees}}</template>
                        </el-table-column>
                        <el-table-column label="Select" min-width="70">
                          <template slot-scope="props">
                            <div>
                              <el-popconfirm
                                confirmButtonText='OK'
                                cancelButtonText='Cancel '
                                icon="el-icon-info"
                                iconColor="red"
                                @confirm="setClassroom(order.customer.id,product.id,product.classRoom.id,props.row.id)"
                                :title="'This will resend the booking email, Are you sure?'"
>
                              <el-button
                                slot="reference"
                                plain
                                type="primary"
                                :disabled="props.row.maxAttendees==props.row.numAttendees || product.classRoom.code==props.row.code"
                               
                              >select</el-button>
                              </el-popconfirm>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-dialog>

                    <div class="col-md-4 col-sm-12 text-center" v-if="product.product.type=='classroom course' || product.product.type=='combined course' ">
                      
                      <el-button
                        plain
                        type="primary"

                        class="btn btn-primary btn-block"
                        @click="changeClassroomVisible=true;showIt='classroomfilter'"
                      >Change Class Dates</el-button>
                    
                    </div>
                    <div class="col-md-5 col-sm-12 text-center" v-if="product.product.type=='combined course'">
                      <el-button
                        plain
                        type="primary"
                        class="btn-block"
                        :loading="sendingEmail"
                        @click="sendPartial(product.id)"
                      >Send Partial Completion Letter</el-button>
                    </div>
                    <div class="col-md-3 col-sm-12 text-center" v-if="product.certSent">
                      <el-button
                        plain
                        type="primary"
                        class="btn-block"
                        @click="openCert(product.certUrl)"
                      >View cert pdf</el-button>
                    </div>
                    <div class="col-md-3 col-sm-12 text-center" v-if="order.status=='2' && product.certDue == '1' && (product.product.type=='online course' || product.product.type=='classroom course' || product.product.type=='combined course' )">
                      <el-button
                        plain
                        type="primary"
                        class="btn-block"
                        @click="createCert(product.id)"
                      >Create Certificate</el-button>
                    </div>

                    <div class="col-xs-12"><p><br><br><small v-if="product.certDue == '0'">Note: Certificate not yet approved, the option to create a certificate will show here once it is approved.</small></p></div>
                    
                  </div>
                  </div>
                </div> 
              </div>
             
            </div>
          </el-card>
        </div>

        <!-- ORDER AMOUNTS -->

        <div class="col-lg-6">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Order Amounts</h4>
            </div>
            <div class="card-content">
              <div class="row">
                <div class="col-md-6">
                  <h5>Transactions:</h5>
                   <div class="row">
                    <div class="col-md-6">
                      <label class="text-danger control-label">Outstanding: </label><br>
                      {{order.totalDue | priceLabelToSymbol(order.productPriceLabel)}}
                    </div>
                    <div class="col-md-5">
                      <label class="text-success control-label">Amount paid:</label><br>
                      {{order.totalPaid | priceLabelToSymbol(order.productPriceLabel)}}
                      <span v-for="(transaction,index) in order.transactions"
                            :key="index">
                                <img
                                  v-if="transaction.method == 'Paypal'"
                                  src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png"
                                  border="0"
                                  alt="PayPal Logo"
                                  width="70"
                                  style="margin-bottom:10px"
                                />
                                <img
                                  v-if="transaction.method == 'Stripe' &&  transaction.reference != ''"
                                  src="https://cdn-wp.tefl.org/wp-content/themes/tefl/img/powered_by_stripe.svg"
                                  border="0"
                                  alt="Stripe Logo"
                                  width="70"
                                  style="margin-bottom:10px"
                                />
                        </span>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="text-success control-label">Order Discounted:</label><br>
                      {{order.boughtProductTotalDiscounted | priceLabelToSymbol(order.productPriceLabel)}}
                    </div>
                    <div class="col-md-5">
                      <label class="text-success control-label">Order Total:</label><br>
                      {{order.boughtProductTotal | priceLabelToSymbol(order.productPriceLabel)}}
                   </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-12"
                    v-if="order.discount != null"
                    >
                    <h5>Promotion:</h5>
                   
                   
                        <h5><strong class="text-warning">"{{order.discount.code}}"</strong></h5>
                        <strong
                            v-if="order.discount.discountPercentage != 0"
                          >{{order.discount.discountPercentage}}% off</strong>
                        <strong
                            v-if="order.discount.discountFlat != 0"
                          >{{order.discount.discountFlat | priceLabelToSymbol(order.productPriceLabel)}} off</strong>
                        {{order.discount.type}}
             
                </div>
                <div v-else> 
                  <h5>Promotion:</h5>No Promotion applied
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
              
                      
                          
                  
                </div>
              </div>
            </div>

              <div class="row">
                <div class="col-xs-12">
                  <hr />
                  <el-collapse accordion>
                    <el-collapse-item class="clear" title="Transactions" name="2">
                      <div class="card-content">
                        
                        <div class="col-md-12">
                          <h4>Add Manual Transaction</h4>
                          <div class="row">
                            <div class="form-group col-md-3">
                              <fg-input
                                type="text"
                                label="Amount"
                                placeholder="Amount"
                                width="50px"
                                v-model="newTransaction.amount"
                              ></fg-input>
                            </div>
                            <div class="form-group col-md-6">
                              <fg-input
                                type="text"
                                label="Detail"
                                placeholder="Detail"
                                v-model="newTransaction.detail"
                              ></fg-input>
                            </div>
                            <div class="form-group col-md-3">
                              <br />
                              <button
                                class="btn btn-info btn-sm"
                                :disabled="addingTransaction"
                                @click="saveTransaction()"
                              >{{transactionText}}</button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <hr />
                        </div>
                        <div class="col-md-12">
                          <h4>Transaction Details</h4>
                          <div
                            class="row"
                            v-for="(transaction,index) in order.externalPayments"
                            :key="index"
                          >
                            <div class="col-md-12">
                              <h5>External/Manual</h5>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label class="control-label">Date</label>
                                <span
                                  class="text-success form-control text-small"
                                >{{transaction.dateCreated | moment("DD/MM/YY h:mm:ss a")}}</span>
                              </div>
                            </div>

                            <div class="col-md-3">
                              <div class="form-group">
                                <label class="control-label">Paid</label>
                                <span
                                  class="text-success form-control"
                                >{{transaction.amount | priceLabelToSymbol(order.productPriceLabel)}}</span>
                              </div>
                            </div>
                            
                            <div class="col-md-3">
                              <div class="form-group">
                                <label class="control-label">ID</label>
                                <span class="text-success form-control">{{transaction.id}}</span>
                              </div>
                            </div>
                            <div class="col-md-10">
                              <div class="form-group">
                                <label class="control-label">Description</label>
                                <textarea class="text-success form-control">{{transaction.description}}</textarea>
                              </div>
                            </div>
                            <div class="col-lg-2">
                              <div
                                class="btn btn-danger btn-sm btn-ws"
                                @click="removeExternalPayment(transaction.id)"
                              >
                                <i class="fa fa-close"></i>Delete
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <hr />
                            </div>
                          </div>
                          <div
                            class="row"
                            v-for="(transaction,index) in order.transactions"
                            :key="index"
                          >
                            <div
                              class="card"
                              style="
                                  border: 1px solid #dd3a2a;
                                  padding: 20px 0;
                                  float: left;
                                  outline: none;"
                              v-if="transaction.amountPaid == 0"
                            >
                              <div class="col-md-12">
                                <img
                                  v-if="transaction.method == 'PayPal'"
                                  src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png"
                                  border="0"
                                  alt="PayPal Logo"
                                  width="100"
                                  style="margin-bottom:10px"
                                />
                                <img
                                  v-if="transaction.method == 'Stripe'"
                                  src="https://cdn-wp.tefl.org/wp-content/themes/tefl/img/powered_by_stripe.svg"
                                  border="0"
                                  alt="Stripe Logo"
                                  width="100"
                                  style="margin-bottom:10px"
                                />
                                <a
                                  class="btn btn-xs"
                                  style="margin:-8px 0 0 5px;"
                                  v-if="transaction.method == 'PayPal' && transaction.reference != 'N/A'"
                                  :href="'https://www.paypal.com/activity/payment/'+transaction.reference"
                                  target="_BLANK"
                                >View</a>
                                <a
                                  class="btn btn-xs"
                                  style="margin:-8px 0 0 5px;"
                                  v-if="transaction.method == 'Stripe' && transaction.reference != 'N/A'"
                                  :href="'https://dashboard.stripe.com/payments/'+transaction.reference"
                                  target="_BLANK"
                                >View</a>
                                <small class="label label-danger pull-right">
                                  <i class="fa fa-times"></i>
                                  Error
                                </small>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="control-label">Date</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.dateCreated | moment("DD/MM/YY h:mm:ss a")}}</span>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label class="control-label">Currency</label>
                                  <span class="text-success form-control">{{transaction.currency}}</span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label class="control-label">Attempted</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.amountAttempted | priceLabelToSymbol(order.productPriceLabel)}}</span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label class="control-label">Paid</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.amountPaid | priceLabelToSymbol(order.productPriceLabel)}}</span>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label class="control-label">ID</label>
                                  <span class="text-success form-control">{{transaction.id}}</span>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="control-label">Payment Processor</label>
                                  <span class="text-success form-control">{{transaction.method}}</span>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="control-label">Reference</label>
                                  <span class="text-success form-control">{{transaction.reference}}</span>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label class="control-label">Error message</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.failureMessage}}</span>
                                </div>
                              </div>
                              <div class="col-lg-2">
                                <div
                                  class="btn btn-danger btn-sm btn-ws"
                                  @click="deleteTransaction(transaction.id)"
                                >
                                  <i class="fa fa-close"></i>Delete
                                </div>
                              </div>
                            </div>
                            <div
                              v-else
                              class="card"
                              style="
                                  padding: 20px 0;
                                  border: 1px solid #2EA18B;
                                  float: left;
                                  outline: none;"
                            >
                              <div class="col-md-12">
                                <img
                                  v-if="transaction.method == 'PayPal'"
                                  src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png"
                                  border="0"
                                  alt="PayPal Logo"
                                  width="100"
                                  style="margin-bottom:10px"
                                />
                                <img
                                  v-if="transaction.method == 'Stripe'"
                                  src="https://cdn-wp.tefl.org/wp-content/themes/tefl/img/powered_by_stripe.svg"
                                  border="0"
                                  alt="Stripe Logo"
                                  width="100"
                                  style="margin-bottom:10px"
                                />
                                <a
                                  class="btn btn-xs"
                                  style="margin:-8px 0 0 5px;"
                                  v-if="transaction.method == 'PayPal'"
                                  :href="'https://www.paypal.com/activity/payment/'+transaction.reference"
                                  target="_BLANK"
                                >View</a>
                                <a
                                  class="btn btn-xs"
                                  style="margin:-8px 0 0 5px;"
                                  v-if="transaction.method == 'Stripe'"
                                  :href="'https://dashboard.stripe.com/payments/'+transaction.reference"
                                  target="_BLANK"
                                >View</a>
                                <small class="label label-success pull-right">
                                  <i class="fa fa-check"></i>
                                  Success
                                </small>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="control-label">Date</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.dateCreated | moment("DD/MM/YY h:mm:ss a")}}</span>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label class="control-label">Currency</label>
                                  <span class="text-success form-control">{{transaction.currency}}</span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label class="control-label">Attempted</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.amountAttempted | priceLabelToSymbol(order.productPriceLabel)}}</span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label class="control-label">Paid</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.amountPaid | priceLabelToSymbol(order.productPriceLabel)}}</span>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label class="control-label">ID</label>
                                  <span class="text-success form-control">{{transaction.id}}</span>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="control-label">Payment Processor</label>
                                  <span class="text-success form-control">{{transaction.method}}</span>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="control-label">Reference</label>
                                  <span class="text-success form-control">{{transaction.reference}}</span>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="control-label">Details</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.description}}</span>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="control-label">teflId (Campaign tracking)</label>
                                  <span
                                    class="text-success form-control"
                                  >{{transaction.teflId}}</span>
                                </div>
                              </div>
                              <div class="col-lg-2">
                                <div
                                  class="btn btn-danger btn-sm btn-ws"
                                  @click="deleteTransaction(transaction.id)"
                                >
                                  <i class="fa fa-close"></i>Delete
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-collapse-item>
                    <hr />
                    <el-collapse-item class="clear" title="Notes" name="3">
                      <!-- NOTES -->

                      <div class="col-xs-12">
                        <VuePellEditor
                          v-model="newNote"
                          :style-with-css="false"
                          default-paragraph-separator="p"
                        />
                        <br />
                        <button type="button" class="btn btn-wd btn-primary" @click="saveNote">
                          <span class="btn-label">
                            <i class="fa fa-plus"></i>
                          </span>
                          Add Note
                        </button>

                        <br />
                        <br />
                        <hr />
                      </div>

                      <div v-for="(note,index) in notes" :key="index">
                        <div class="col-lg-10">
                          <div v-html="note.detail">{{note.detail}}</div>
                          <br />
                          <H6 class="text-muted" style="font-weight:400">
                            <i class="ti-time"></i> Added By
                            <span class="text-danger">{{note.createdBy}}</span>
                            - {{ note.dateCreated | moment("DD/MM/YYYY, h:mm:ss a") }}
                          </H6>
                          <br />

                          <hr />
                        </div>

                        <div class="col-lg-2">
                          <div class="btn btn-danger btn-sm btn-ws" @click="deleteNote(note.id)">
                            <i class="fa fa-close"></i>
                          </div>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </div>
          </el-card>
          
        </div>
      </div>

      <div class="row" style="margin-top:30px;">
        <div class="col-md-6 col-md-offset-6 text-right">
          <el-button type="danger" @click="toggleDialog('delete')">Delete Order Permanently</el-button>
          <el-button type="warning" @click="toggleDialog('cancel')">Cancel Order (data will remain)</el-button>
          <br />
          <br />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <p>
            <br />
          </p>
        </div>
      </div>

      <el-dialog
        title="Confirm Delete"
        :visible.sync="deleteDialogVisible"
        width="30%"
        :modal="false"
      >
        <span>This will permanently delete the order, are you sure?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">No, go back</el-button>
          <el-button type="danger" @click="doDelete">Yes, delete the order</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="Confirm Cancel"
        :visible.sync="cancelDialogVisible"
        width="30%"
        :modal="false"
      >
        <span>This will cancel the order, the data will remain. Are you sure?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialogVisible = false">No, go back</el-button>
          <el-button type="warning" @click="cancelBooking">Yes, cancel the order</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import PSwitch from "src/components/UIComponents/Switch.vue";
import Classroomfilter from "src/components/UIComponents/ClassroomFilter";

import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
//import striptags  from 'striptags';
import VuePellEditor from "vue-pell-editor";
import UnitTranscript from "../UIComponents/UnitTranscript.vue";
import { orderBy } from "lodash";

export default {
  components: {
    PSwitch,
    Classroomfilter,
    VuePellEditor,
   UnitTranscript
  },
  props: ["id"],
  data() {
    return {
      changeClassroomVisible: false,
      order: {},
      boughtProducts: {},
      sendingEmail: false,
      classrooms: [],
      showIt: "",
      statuses: [
        {
          value: "0",
          label: "Pending"
        },
        {
          value: "1",
          label: "Deposit Paid"
        },
        {
          value: "2",
          label: "Fully Paid"
        },
        {
          value: "4",
          label: "Cancelled"
        }
      ],
      adjustment: {},
      newTransaction: {},
      today: moment().format("YYYY-MM-DD"),
      loading: false,
      customers: {},
      newVariantPrice: [],
      addingTransaction: false,
      transactionText: "Add transaction",
      toggleExtras: false,
      toggleAssigning: false,
      cancelDialogVisible: false,
      deleteDialogVisible: false,
      discounts: [],
      changeClass: false,
      settingClass: false,
      editExpiryDate: [],
      updatingExpiry: false,
      expiryText: "Update",
      newExpiryDate: {},
      notes: [],
      newNote: ""
    };
  },
  methods: {
    getStep() {
      return "1";
    },

    openCert: function(url) {
      if (url.substring(0, 3) == "app") {
        url = "http://crm.tefl.org.uk/" + url;
      }
      window.open(url, "_blank");
    },
    getUserMeta(user) {
      return _.filter(this.order.orderProductVariants[0].userMetaData, function(
        o
      ) {
        return o.userId == user;
      });
    },
    createCert(id) {
      let data = {};
      data.customer = this.order.customer;
      data.boughtProducts = this.order.boughtProducts.filter(bp => bp.id == id);
      api.createCert(data).then(res => {
        console.log(res);
        window.open(res.data);
        this.loadingCertificates = false;
      });
    },

    resendBooking() {
      api.resendBooking({ order_id: this.order.id }).then(response => {
        if (response.statuscode == "502")
          this.$notify({ message: response.body, type: "error" });
        else {
          var result = JSON.parse(response.body);
          if (result.accepted.length > 0)
            this.$notify({
              message:
                "Email Sent To: " + JSON.stringify(result.accepted[0].email),
              type: "success"
            });
          else
            this.$notify({
              message:
                "Email Not Sent: " +
                JSON.stringify(result.rejected[0].reject_reason),
              type: "error"
            });
        }
        console.log(response);
      });
    },
    sendPartial(obp) {
      this.sendingEmail = true;
      api.sendPartial({ obp_id: obp }).then(response => {
        this.sendingEmail = false;
        this.$notify({
          message:
            "Email sent to user: " +
            JSON.parse(response.body).accepted[0].email,
          type: "success"
        });
      });
    },

    setClassroom(customer_id, obpId, oldId, newId) {
      console.log("old: " + this.oldId);
      console.log("new: " + this.newId);
      this.settingClass = true;
      let id = this.order.id;
      api
        .changeClassroom({
          customer_id: customer_id,
          obpId: obpId,
          oldId: oldId,
          newId: newId,
          order_id: id
        })
        .then(response => {
          this.getOrder(id);
          this.$notify({
            message: "Classroom Changed " + response.data,
            type: "success"
          });
          this.settingClass = false;
        });
    },

    saveNote() {
      this.newNote = this.stripHTML();
      let q = gql`
     mutation AddNote {
        insert_Note(objects: {customerId: ${this.order.customer.id}, detail: "${
        this.newNote
      }", createdBy: "${this.user.email}",dateCreated:"${moment().format(
        "YYYY-MM-DDTHH:mm:ss"
      )}"}) {
          returning {
            id
            detail,
            createdBy,
            dateCreated
          }
        }
      } `;
      this.$apollo
        .mutate({
          mutation: q
        })
        .then(result => {
          console.log(result);
          this.notes.unshift(result.data.insert_Note.returning[0]);
          this.$notify({
            title: "Updated",
            message: "Note Saved",
            type: "success"
          });
        });
    },
applyExtension(obpid,extid){
      let data={}
      data.obpid=obpid;
      data.extid=extid;
      api.applyExtension(data).then(response => {
        this.$notify({ message: "Extension Applied", type: "success" });
        this.getOrder(this.$route.params.id);
      });
    },

    addExtension(id,extension) {
      console.log('adding extension... ',id)
      if(extension == '1week'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneWeekExtensions: 1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '1month'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneMonthExtensions: 1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '2months'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { twoMonthExtensions: 1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '3months'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { threeMonthExtensions: 1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      }
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: id,
          }
        })
        .then(result => {
          this.$notify({
            title: "Updated",
            message: "Extensions Updated",
            type: "success"
          });
          //return result;
          this.getOrder(this.$route.params.id)
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },

    removeExtension(id,extension) {
      console.log('removing extension... ',id)
      if(extension == '1week'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneWeekExtensions: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '1month'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneMonthExtensions: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '2months'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { twoMonthExtensions: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '3months'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { threeMonthExtensions: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '1weekpost'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneWeekExtensionsPost: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '1monthpost'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { oneMonthExtensionsPost: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '2monthspost'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { twoMonthExtensionsPost: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      } else if(extension == '3monthspost'){
        var q = gql`
          mutation update_status($id: Int) {
            update_OrderBoughtProduct(where: { id: { _eq: $id } }, _inc: { threeMonthExtensionsPost: -1 }) {
              affected_rows
              returning {
                id
              }
            }
          }
        `;
      }
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: id,
          }
        })
        .then(result => {
          this.$notify({
            title: "Updated",
            message: "Extensions Updated",
            type: "success"
          });
          //return result;
          this.getOrder(this.$route.params.id)
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },
    deleteNote(id) {
      let q = gql`
        mutation MyMutation {
          __typename
          delete_Note(where: {id: {_eq: ${id}}}) {
            affected_rows
          }
        }
      `;
      this.$apollo
        .mutate({
          mutation: q
        })
        .then(result => {
          this.notes = _.reject(this.notes, o => {
            return o.id == id;
          });
          this.$notify({
            title: "Updated",
            message: "Note Deleted",
            type: "success"
          });
        });
    },

    stripHTML() {
      const text = this.newNote;
      var pastedData = text.replace(/(<([^>]+)>)/gi, ""); // remove all html except the listed tags

      let wrapper = document.createElement("div");
      wrapper.innerHTML = pastedData;

      var sanitised = wrapper.textContent || wrapper.innerText;
      this.newNote = sanitised;

      return this.newNote;
    },

    getOrder(id) {
      console.log("getOrder" + id);
      var today = this.today;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          fetchPolicy: "no-cache",
          query: gql`
          
            {
              Order(where: {id: {_eq: "${id}"}}) {
                id
                customer {
                  id
                  email
                  firstname
                  middlenames
                  lastname
                  hasPaid
                  numLogin
                  title
                  shippingAddress {
                    id
                    phone
                  }
                }
                boughtProductTotal
                boughtProductTotalDiscounted
                totalPaid
                totalDue
                status
                productPriceLabel
                historic
                dateCreated
                dateUpdated
                externalPayments{
                  id
                  dateCreated
                  amount
                  description
                }
                transactions {
                  id
                  amount
                  amountAttempted
                  amountPaid
                  createdBy
                  currency
                  dateCreated
                  dateUpdated
                  description
                  failureMessage
                  method
                  type
                  reference
                }
                boughtProducts {
                  id
                  orderId
                  cachedTeflLmsCourseId
                  passedDate
                  orderPaymentStatus
                  product {
                    id
                    name
                    type
                    description
                    certificateText
                    certificateSmallText
                    learningOutcomes
                    course{
                      type
                      hours
                    }
                    prices(where: {dateFrom: {_lte: "${today}"}, dateTo: {_gte: "${today}"}}) {
                      id
                      label
                      cost
                      dateFrom
                      dateTo
                    }
                    courseId
                    onlineCourseId
                    classRoomCourseId
                  }
                  classRoom {
                    id
                    code
                    startDate
                    endDate
                    isOnline
                    venue {
                      id
                      city
                      country
                      town
                      name
                    }
                  }
                  certRequested
                  certSent
                  certDue
                  certSentDate
                  certUrl
                  classRoomCourseAttended
                  classRoomCoursePassed
                  onlineCourseExpiryDate
                  onlineCourseExpiryDateSet
                  onlineCoursePassed
                  signedLearnerAgreement
                  signedDate
                  oneMonthExtensions
                  oneMonthExtensionsPost
                  oneWeekExtensions
                  oneWeekExtensionsPost
                  threeMonthExtensions
                  threeMonthExtensionsPost
                  twoMonthExtensions
                  twoMonthExtensionsPost
                  relativeOrderBoughtProductId
                }
                discount {
                  id
                  code
                  discountFlat
                  discountPercentage
                  type
                }
              }
            }
          
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.order = response.data.Order[0];
          this.boughtProducts = response.data.Order[0].boughtProducts;
          console.log("Order: ", this.order.id);
          this.loadingOrders = false;
          this.getNotes(this.order.customer.id);
          //this.getBoughtProducts(this.order.id);
        });
    },

    getRelativeOrder(id) {
      console.log("getRelativeOrder" + id);
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          fetchPolicy: "no-cache",
          query: gql`
            {
              Order(where: {boughtProducts: {id: {_eq: "${id}"}}}) {
                id
              }
            }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.relativeOrderID = response.data.Order[0].id;
          window.open(
            "/#/order/edit/" +this.relativeOrderID
          );
          //this.getBoughtProducts(this.order.id);
        });
    },

    getNotes(id) {
      console.log("getNotes: " + id);
      var today = this.today;
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          fetchPolicy: "no-cache",
          query: gql`
          
            {
              Note(where: {customerId: {_eq: "${id}"}}, order_by: {dateCreated: desc}) {
                createdBy
                customerId
                dateCreated
                dateUpdated
                detail
                id
                updatedBy
              }
            }
          
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.notes = response.data.Note;
          //this.getBoughtProducts(this.order.id);
        });
    },

    toggleDialog(type) {
      if (type === "cancel") {
        this.cancelDialogVisible = !this.cancelDialogVisible;
      }
      if (type === "delete") {
        this.deleteDialogVisible = !this.deleteDialogVisible;
      }
    },

    toggleExpiry(id) {
      this.editExpiryDate.indexOf(id) === -1
        ? this.editExpiryDate.push(id)
        : this.editExpiryDate.splice(this.editExpiryDate.indexOf(id), 1);
    },

    loginAsCustomer() {
      const loginAs = api.loginAsCustomer({
        username: this.order.customer.email
      }); //axios.get(this.usersUrl);
      Promise.resolve(loginAs).then(result => {
        console.log(result);
        this.session = result.data.jwt_token;
        this.userid = result.data.user_id;
        window.open(
          "https://www.tefl.org/my-account/?session=" +
            this.session +
            "&userid=" +
            this.userid
        );
      });
    },

    updateExpiryDate(obpid) {
      this.updatingExpiry = true;
      this.expiryText = "Processing...";
      console.log("obpid: ", obpid, this.newExpiryDate[obpid]);
      ///tc-orders/[ORDERID]/transactions/
      api
        .updateExpiry({
          order_bought_product_id: obpid,
          product_expiry: this.newExpiryDate[obpid]
        })
        .then(response => {
          console.log("ok", response.data);
          this.order = response.data;
          //this.getOrder(this.$route.params.id);
          this.$notify({ message: "Expiry date updated", type: "success" });
          this.updatingExpiry = false;
          this.expiryText = "Update";
        });
    },

    saveAdjustment() {
      if (!this.adjustment.plusMinus) {
        this.adjustment.amount = this.adjustment.amount * -1;
      }
      const saveAdjustmentPromise = api.saveAdjustment({
        orderId: this.order.id,
        amount: this.adjustment.amount,
        detail: this.adjustment.detail,
        byUserId: this.user.id
      }); //axios.get(this.usersUrl);
      Promise.resolve(saveAdjustmentPromise).then(response => {
        console.log("ok", response.data);
        this.order = response.data.data;
        this.adjustment = {};
      });
    },

    saveTransaction() {
      this.addingTransaction = true;
      this.transactionText = "Processing...";
      ///tc-orders/[ORDERID]/transactions/
      api
        .saveTransaction({
          orderId: this.order.id,
          transaction: this.newTransaction
        })
        .then(response => {
          console.log("ok", response.data);
          //this.order = response.data;
          this.$notify({ message: "Transaction Saved", type: "success" });
          this.addingTransaction = false;
          this.transactionText = "Add transaction";
          this.newTransaction = {};
          this.getOrder(this.$route.params.id);
        });
    },

    removeExternalPayment(id) {
      api
        .removeExternalPayment({
          orderId: this.order.id,
          id: id
        })
        .then(response => {
          console.log("ok", response.data);
          this.order = response.data;
          //this.getOrder(this.$route.params.id);
          this.$notify({ message: "Transaction Removed", type: "success" });
        });
    },

    setVariantPrice(id, price) {
      ///tc-orders/[ORDERID]/set_variant_price/
      api
        .setVariantPrice({
          orderId: this.order.id,
          productVariantId: id,
          price: price
        })
        .then(response => {
          console.log("ok", response.data);
          this.order = response.data.data;
          this.$notify({ message: "Price Updated", type: "success" });
        });
    },

    deleteTransaction(id) {
      ///tc-orders/[ORDERID]/transactions/[TRANSACTIONID]/delete
      api
        .deleteTransaction({ orderId: this.order.id, transactionId: id })
        .then(response => {
          this.order = response.data.data;
          this.$notify({ message: "Transaction Deleted", type: "success" });
        });
    },

    //getVariants:
    deleteAdjustment(id) {
      const deleteAdjustmentPromise = api.deleteAdjustment({
        orderId: this.order.id,
        adjustmentId: id
      }); //axios.get(this.usersUrl);
      Promise.resolve(deleteAdjustmentPromise).then(response => {
        console.log("ok", response.data);
        this.order = response.data.data;
      });
    },

    removeAttendee(customerId, classroomId) {
      const now = moment().format();
      const query = gql`
        mutation deleteClassRoomAttendee(
          $customerId: Int!
          $classroomId: Int!
        ) {
          delete_ClassRoomAttendee(
            where: {
              _and: {
                customerId: { _eq: $customerId }
                classRoomId: { _eq: $classroomId }
              }
            }
          ) {
            affected_rows
          }
          update_ClassRoom(
            where: { id: { _eq: $classroomId } }
            _inc: { numAttendees: -1 }
          ) {
            affected_rows
          }
        }
      `;
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: query,
          variables: {
            customerId: customerId,
            classroomId: classroomId
          }
        })
        .then(result => {
          this.$notify({
            title: "Attendee Removed",
            message: "Customer removed from classroom attendees",
            type: "success"
          });
          //this.$router.push({ path: '/booking/list'})
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },

    deleteOrder() {
      //Delete Order
      //this.order = response.data.data;
      const q = gql`
        mutation delete_order($id: Int) {
          delete_Order(where: { id: { _eq: $id } }) {
            affected_rows
          }
        }
      `;
      this.$apollo
        /// You must strip out the nested objects and only send the product object
        .mutate({
          mutation: q,
          variables: {
            id: this.order.id
          }
        })
        .then(result => {
          this.$notify({
            title: "Deleted",
            message: "Order deleted",
            type: "success"
          });
          this.$router.push({ path: "/order/list" });
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
      //this.$router.push({ path: '/booking/list'})
    },

    sleeper(ms) {
      return function(x) {
        return new Promise(resolve => setTimeout(() => resolve(x), ms));
      };
    },

    doDelete() {
      //Cancel then delete
      const cancelBookingFirst = this.cancelBooking();
      Promise.resolve(cancelBookingFirst).then(this.sleeper(10000)).then(response => {
          console.log("cancelBookingFirst: ", response);
          const deleteOrder = this.deleteOrder();
          Promise.resolve(deleteOrder).then(response => {
            console.log("deleteOrder: ", response);
          });
      });

    },

    cancelBooking() {
      //Remove attendee from any classrooms
      let $classroom = false;
      for (let $i = 0; $i < this.order.boughtProducts.length; $i++) {
        if (this.order.boughtProducts[$i].classRoom) {
          //Remove customer
          $classroom = true;
          const removeAttendee = this.removeAttendee(
            this.order.customer.id,
            this.boughtProducts[$i].classRoom.id
          );
          Promise.resolve(removeAttendee).then(response => {
            console.log("removeAttendee: ", response);
          });
        }
      }

      //Set status to 4 ('cancelled')
      this.order.status = "4";

      const cancelBooking = this.updateStatus();
      Promise.resolve(cancelBooking).then(response => {
        console.log("cancelBooking: ", response);
        this.cancelDialogVisible = false;
      });
    },

    updateStatus() {
      if(this.order.status == '2' && this.order.totalDue == null){
        this.newTransaction.amount = String(this.order.boughtProductTotalDiscounted);
        this.newTransaction.detail = 'Manually changed status to fully paid';
        this.saveTransaction();
      } else if(this.order.status == '2' && this.order.totalDue > 0){
        this.newTransaction.amount = String(this.order.totalDue);
        this.newTransaction.detail = 'Manually changed status to fully paid';
        this.saveTransaction();
      } else {
        const q = gql`
          mutation update_status($id: Int, $status: String) {
            update_Order(where: { id: { _eq: $id } }, _set: { status: $status }) {
              affected_rows
              returning {
                status
              }
            }
          }
        `;
        this.$apollo
          /// You must strip out the nested objects and only send the product object
          .mutate({
            mutation: q,
            variables: {
              id: this.order.id,
              status: this.order.status
            }
          })
          .then(result => {
            this.$notify({
              title: "Updated",
              message: "Order Status Updated",
              type: "success"
            });
            this.getOrder(this.$route.params.id)
            //return result;
          })
          .catch(error => {
            this.$notify({
              title: "Error",
              message: error.message,
              type: "error"
            });
          });
      }
    },

    editMeta() {
      const editMeta = api.editMeta(this.order.id, this.order.meta["note"]);
      Promise.resolve(editMeta).then(response => {
        if (response.error_message == "Not Found") {
          this.order = {};
        } else {
          this.order = response.data.data;
          this.$notify({ message: "Note Updated", type: "success" });
          //this.$router.push({ path: '/booking/list'})
        }
      });
    },

    remoteMethod(query) {
      if (query != "" && query.length > 2) {
        this.getCustomers(query);
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      } else {
        this.customers = {};
      }
    },

    getJobID(str){
      //id = string.slice(string.lastIndexOf(' ') + 1);
      var n = str.lastIndexOf(' ');
      var id = str.substring(n + 1);
      return id;
    }
  },

  mounted() {
    this.getOrder(this.$route.params.id);
  },

  watch: {
    "this.$route.params.id": function(id) {
      console.log("watching...");
      this.getOrder(id);
    }
  },

  computed: {
    user() {
      return this.$store.getters.getProfile;
    }
  }
};
</script>
<style>
tr.warning-row {
  background: rgb(199, 197, 197);
}

div.fully > div.el-input.el-input--suffix > input{
background-color:#def6d1;
border-color:#dcf5d0;
color: #67c23a;
}
div.pending > div.el-input.el-input--suffix > input{

background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
}
div.deposit > div.el-input.el-input--suffix > input{
    color: #e6a23c;
    background: #fdf6ec;
    border-color: #f5dab1;
}
</style>


// WEBPACK FOOTER //
// src/components/Orders/Edit.vue